import React from 'react';
import clsx from 'clsx';

const Row = ({ 
    children, 
    marginUp = true, 
    marginDown = true,
    size = 'large', // large or medium
}) => {
    return (
        <div className={clsx(`row-${size}`, { "margin-up": marginUp, "margin-down": marginDown })}>
            { children }
        </div>
    );
}

export default Row;